import React, { StrictMode, useEffect, useState } from 'react'
import { AppBar, Avatar, Badge, Box, Button, CircularProgress, Container, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Popover, Stack, TextField, Toolbar, Typography, useTheme } from "@mui/material";
import { ArrowDownIcon, CartIcon, EditIcon, EmailIcon, LogoutIcon, MenuIcon, NotificationIcon, PhoneIcon } from "./IconComponent";
import { getCountryDefaultByCode, getLanguage, getLogoImage, logOut, storeLanguageAsync } from '../utils/common';
import { getMenuConfig, menu_config } from '../menu.config';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import crmservices from '../wsclient';
import { commonFont } from '../theme';
import { custom_menu_config } from '../custom.config'
import { config_path, portalCfg } from '../router/config.path';
import ConfirmComponent from './Confirm';
import AlertComponent from './Alert';
import { cache, order_key } from '../utils/cache';
import Modal from './Modal';
import LoadingComponent from './Loading';

function CustomHeader() {
    const [showProcessing, setShowProcessing] = useState(false);
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [logoImage, setLogoImage] = useState(getLogoImage());
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [currentLanguage, setCurrentLanguage] = useState(getLanguage())
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [menuSelected, setMenuSelected] = useState({});
    const [confirm, setConfirm] = useState({});
    const [message, setMessage] = useState(null);
    const [target, setTarget] = useState({});
    const [fullName, setFullName] = useState();
    const [anchorElLanguage, setAnchorElLanguage] = useState(null);

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { palette, spacing, breakpoints } = useTheme();

    useEffect(() => {
        const sessionData = crmservices.getSession();
        if (sessionData && sessionData.full_name) {
            setFullName(sessionData.full_name)
        }
    }, [])

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const onClickMenu = (item, event) => {
        if (item.sub_menu && item.sub_items && item.sub_items.length > 0) {
            if (menuSelected && menuSelected.id != item.id) {
                setMenuSelected(item)
                setShowSubMenu(true);
            }
            else {
                setShowSubMenu(false)
                setMenuSelected({})
            }
        }
        else if (item.route) {
            handleCloseUserMenu()
            navigate(item.route)
        } else {
            handleCloseUserMenu()
            onClickItemProcess(item.fnc, event, item.id)
        }
    }

    const onClickItemProcess = async (fnc, event, target) => {
        console.log('TARGETE NNENENE: ' + target);//todo: xoa
        console.log("fnc:", fnc);
        if (fnc == 'Logout') {
            await onLogout(event)
        } else {
            setTarget({
                [target]: true,
            })
        }
    }

    const onLogout = (event) => {
        setAnchorElUser(event.currentTarget);
        logOut(undefined, navigate)

    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const handleOpenLanguages = (event) => {
        setAnchorElLanguage(event.currentTarget);
    };

    const onChangeLanguage = async (item) => {
        setAnchorElLanguage(null);
        setShowProcessing(true)
        let _language = languages.filter(x => x.value == item.value);
        setCurrentLanguage(_language && _language.length > 0 ? _language[0].value : currentLanguage);
        await storeLanguageAsync(item.value);
        await crmservices.contacts.updateContact({ language_code: item.value });
        setShowProcessing(false)
    }

    const languages = cache.getLanguages();
    return (
        <Box borderBottom={1} borderColor={palette.border.main}>
            <Container>
                <AppBar position="static" sx={{ backgroundImage: 'none' }}>
                    <Toolbar disableGutters>
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton sx={{ background: 'transparent' }}
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ flexGrow: 1, cursor: 'pointer' }} onClick={() => navigate(config_path.home)}>
                            <Avatar sx={{ width: 56, height: 56 }} alt="Business Logo" src={logoImage} />
                        </Box>
                        <Box>
                            <Button onClick={(e) => handleOpenLanguages(e)} size='large' id='header/changeLanguage'>
                                {currentLanguage}
                            </Button>
                            <Popover id='list-languages'
                                anchorEl={anchorElLanguage}
                                open={Boolean(anchorElLanguage)}
                                onClose={() => setAnchorElLanguage(null)}
                                sx={{
                                    top: 45,
                                }}
                            >
                                {languages && languages.length > 0 && languages.map((item, index) => {
                                    return (
                                        <MenuItem key={index} onClick={() => onChangeLanguage(item)}>
                                            <Typography variant='subtitle2'>{item.label}</Typography>
                                        </MenuItem>
                                    )
                                })}
                            </Popover>
                            <IconButton onClick={onLogout} size="large" color="inherit" sx={{ background: 'transparent' }} id='headerProfile'>
                                <LogoutIcon/>
                            </IconButton>
                        </Box>
                    </Toolbar>
                </AppBar>
                {showProcessing && <LoadingComponent showLoading={showProcessing} />}
                {message && message.show && <AlertComponent
                    isOpen={message.show}
                    message={message.content}
                    otherMessage={message.otherMessage ? message.otherMessage : null}
                    onClose={message.callBackFn}
                />}
                {confirm && confirm.show && <ConfirmComponent
                    isOpen={confirm.show}
                    message={confirm.message}
                    actionTitle={confirm.actionTitle}
                    closeTitle={confirm.closeTitle}
                    onClose={confirm.onClose}
                    onAction={confirm.onAction}
                />}
            </Container>
        </Box>
    );
}
export default CustomHeader;